import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import { trackPromotionClick } from 'helpers'

export class CTA extends React.PureComponent<CTA.Props, CTA.State> {
  public static sectionId = 'cta';

  public render(): JSX.Element {
    const { section } = this.props
    const { settings } = section
    if (!settings) {
      return <React.Fragment/>
    }

    return (
      <section className={`dynamic-cta ${settings && settings.background ? `bg-${settings.background}` : '' } 
        ${settings && settings.verticalspacing ? 'sm:mb-6-4 mb-1-6' : '' }`}>
        <div className={'max-w-8xl px-1-6 sm:px-2-4 2xl:px-22 xl:px-2-8 mx-auto text-center py-6-4'}>
          <div className={'sm:w-1/2 mx-auto'}>
            <Snippets.Heading 
              className={'mb-1-2 tracking-wider'}
              tag={'h3'}
            >
              {settings.title}
            </Snippets.Heading>

            {settings.content ? (
              <Snippets.RichText className={'mb-3'}>
                {settings.content}
              </Snippets.RichText>
            ) : null}

            {settings.linktext && settings.linkurl ? <Snippets.Button 
              title={settings.linktext}
              onClick={() => trackPromotionClick(
                [{
                  id: section.id,
                  name: settings.title,
                  creative: 'Call to action'
                }],
                settings.linkurl
              )}
              colour={settings.buttonstyle || 'secondary'}
              className={'uppercase tracking-wider'}
            >
              {settings.linktext}
            </Snippets.Button> : null}
          </div>
        </div>
      </section>
    )
  }
}

export namespace CTA {
  export type Options = ShopifyNext.Section<{
    verticalspacing: boolean;
    background: string;
    linktext: string;
    linkurl: string;
    title: string;
    buttonstyle: string;
    content: string;
  }>;
  export interface Props extends GlobalProps {
    section: CTA.Options;
  }
  export interface State {}
}
